import { ExamDetail } from '@ats/api/cm';
import gql from 'graphql-tag';

export const UPDATE_EXAM = gql`
	mutation updateExam($request: UpdateExamRequest!) {
		updateExam(request: $request) {
			id
			status
			state
			examAuthId
		}
	}
`;

export type UpdateExamResponse = Pick<ExamDetail, 'id' | 'status' | 'state' | 'examAuthId'>;
export type UpdateExamMutationResponse = { updateExam: UpdateExamResponse | null };
